import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { useSocialExportConnectedForStation } from '@app/modules/social-export/hooks/useSocialExportConnectedForStation';
import { contentAi } from '@mi-front/api-clients';
import { useState } from 'react';
import { SocialVersionGenerate } from './SocialVersionGenerate';
import { SocialVersionPublish } from './SocialVersionPublish';
import { SocialVersionPublished } from './SocialVersionPublished';
import { SocialVersionUpdate } from './SocialVersionUpdate';

function emptyVersion(
  platformId: contentAi.SocialVersionDtoPlatformEnum,
): contentAi.SocialVersionDto {
  return {
    platform: platformId,
    generation: {
      status: 'NONE',
      data: null,
    },
    userConfig: null,
    uploadId: '',
  };
}

export function ContentSocialVersion({
  content,
  platform,
}: {
  content: contentAi.ContentDto;
  platform: SocialPlatform;
}) {
  const [mode, setMode] = useState<'edit' | 'publish' | 'regenerate' | null>(null);

  const platformConnected = useSocialExportConnectedForStation(
    content.source.data.fragment?.station?.id as string,
    platform,
  );

  if (!platformConnected) {
    return null;
  }

  const version = content.socialVersions.versions.find((v) => v.platform === platform.id);

  if (mode === 'regenerate') {
    return (
      <SocialVersionGenerate
        content={content}
        // @ts-ignore FIX when unifying content-ai and social-export platforms
        version={version ?? emptyVersion(platform.id)}
        allowInstructions
        onCancel={() => setMode('publish')}
        onSuccess={() => setMode('publish')}
      />
    );
  }

  if (
    !version ||
    version.generation.status === 'NONE' ||
    version.generation.status === 'IN_PROGRESS'
  ) {
    return (
      <SocialVersionGenerate
        content={content}
        // @ts-ignore FIX when unifying content-ai and social-export platforms
        version={version ?? emptyVersion(platform.id)}
      />
    );
  }

  if (version.uploadId) {
    return <SocialVersionPublished content={content} version={version} />;
  }

  if (version.userConfig && mode !== 'edit') {
    return (
      <SocialVersionPublish
        content={content}
        version={version}
        onEdit={() => setMode('edit')}
        onRegenerate={() => setMode('regenerate')}
      />
    );
  }

  return (
    <SocialVersionUpdate content={content} version={version} onSave={() => setMode('publish')} />
  );
}
